import { useEffect, useState } from "react";
import { site } from "@/mocks/chigua";

const links = [
  { label: "赛制总览", href: "#about" },
  { label: "参赛名单", href: "#roster" },
  { label: "种子选手", href: "#seeds" },
  { label: "热门瓜料", href: "#hot" },
  { label: "常见问题", href: "#faq" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/90 backdrop-blur-md shadow-[0_1px_0_0_oklch(var(--background-300))]"
          : "bg-transparent"
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-20 md:px-6">
        <a href="#top" className="group flex items-center gap-2.5">
          <span className="relative flex h-9 w-9 items-center justify-center overflow-hidden rounded-full bg-primary-500 text-background-50 ring-2 ring-background-50/60">
            <i className="ri-heart-3-fill text-base leading-none" />
            <span className="absolute inset-0 flex items-center justify-center text-background-50">
              <i className="ri-fire-fill text-[11px]" />
            </span>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">
              {site.brand}
            </span>
            <span className="num-tab text-[9px] tracking-[0.28em] text-primary-600">
              GUA DA SAI · {site.season}
            </span>
          </span>
        </a>

        <div className="hidden items-center gap-1 md:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="rounded-full px-4 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-200/70 hover:text-foreground-950"
            >
              {l.label}
            </a>
          ))}
          <a
            href="#join"
            className="ml-3 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            提交瓜料
          </a>
        </div>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full bg-background-200/70 text-xl text-foreground-900 md:hidden"
        >
          <i className={open ? "ri-close-line" : "ri-menu-line"} />
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-6 pt-3 md:hidden">
          <div className="flex flex-col gap-1">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-3 text-sm text-foreground-800 transition-colors hover:bg-background-200/70"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#join"
              onClick={() => setOpen(false)}
              className="mt-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-3 text-center text-sm font-medium text-background-50"
            >
              提交你的瓜
            </a>
          </div>
        </div>
      )}
    </header>
  );
}